<script>
import moment from "@/utils/moment";
import cycleState from "@/utils/states/cycle";

export default {
  props: {
    cycle: {
      type: Object,
      required: true
    },
    reason: {
      type: String,
      required: true
    }
  },

  methods: {
    reasonText() {
      let statusName = cycleState.getState(this.cycle.status).name;
      let startsAt = moment(this.cycle.starts_at).format("DD [de] MMMM [de] Y");
      let startsText =
        moment() < moment(this.cycle.starts_at) ? "começa" : "começou";

      return this.reason === "status"
        ? `você não conseguirá pagar este ciclo pois o estado atual dele é: <b>${statusName}</b>.`
        : `o período para pagamento do ciclo que ${startsText} em <b>${startsAt}</b>!`;
    }
  }
};
</script>

<template>
  <section>
    <img src="/static/icon-error.svg" height="50px" alt="Temos um problema!" />
    <h2>AH NÃO... TEMOS UM PROBLEMA!</h2>

    <p>
      Olá
      <b>{{cycle.customer.account.first_name}}</b>
      ,
      <span v-html="reasonText()"></span>
      <br />Entre em contato com nosso atendimento para podermos te ajudar da melhor forma.
    </p>
  </section>
</template>

<style scoped>
section {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

p {
  text-align: center;
  font-style: italic;
}

h2 {
  font-size: 18px;
  margin-bottom: 0;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/_Shared/Checkout/CantPayCycle.vue